var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card yellowtunnel rounded p-3 text-white side border-0"},[_c('recent-posts',{attrs:{"recentPostsItems":_vm.recentPostsItems}}),_c('archive',{attrs:{"archiveItems":_vm.archiveItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }